import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-iasubmitnewproposal',
  templateUrl: './iasubmitnewproposal.component.html',
  styleUrl: './iasubmitnewproposal.component.css'
})
export class IasubmitnewproposalComponent {
  
  form = new FormGroup({
    EventName: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]),
    TypeOfComponent: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
    DateOfSubmisison: new FormControl('', [Validators.required]),
    Intervention: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[1-9][0-9]{9}$')]),
    SittingCapacity: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
    InstructorName: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[1-9][0-9]{9}$')]),
    InstructorDesignation: new FormControl('', [Validators.required]),  }
  )
  constructor(private router: Router) { }

  SubmitProposal() {
    this.router.navigate(['/iasubmitnewproposal']);
  }

  onReset() {
    this.form.reset();
    sessionStorage.clear();
    this.router.navigateByUrl('/iaproposalpage');
  }

}
